/**
 * Switch contractor ↔ vendor portal without logging out.
 */
import { selectPortal } from '../api/auth'
import { setPortalPref } from './safeNextPath'

export async function switchPortal(
  portal: 'contractor' | 'vendor',
  opts: { refetch: () => void | Promise<unknown>; navigate: (path: string) => void },
): Promise<void> {
  await selectPortal(portal)
  setPortalPref(portal)
  await opts.refetch()
  opts.navigate(portal === 'vendor' ? '/vendor/dashboard' : '/dashboard')
}
